import instance from "./instance";

const StockListingChronologyAPI = (props) => {
  return instance.get(`/pencatatan-saham?orderBy=${props.orderBy}&limit=${props.limit}&page=${props.page}`);
};

export default StockListingChronologyAPI;
